import { useFormContext } from 'react-hook-form'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

interface DocumentNumberProps {
  value: string
  error: string | undefined
  mandatory: boolean
  readonly?: boolean
  onChange: (value: string) => void
}
const DocumentNumber = ({ value, error, mandatory, readonly, onChange }: DocumentNumberProps) => {
  const { watch } = useFormContext()
  const documentType = watch('documentType')
  const label =
    documentType === 'invoice'
      ? i18n.t('expenses_v2.forms.fields.document_number.label_invoice')
      : documentType === 'receipt'
      ? i18n.t('expenses_v2.forms.fields.document_number.label_receipt')
      : i18n.t('expenses_v2.forms.fields.document_number.label')

  return (
    <TextField
      mandatory={mandatory}
      value={value}
      readonly={readonly}
      error={error}
      label={label}
      placeholder={i18n.t('expenses_v2.forms.fields.document_number.placeholder')}
      onChange={(documentNumber) => onChange(documentNumber)}
    />
  )
}

export default DocumentNumber
